import { Injectable } from '@angular/core';
import { EventProperties } from '../yesno-service/models';

let gtag: Gtag.Gtag;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  public load(opts?: { enabled?: boolean }): void {
    if (opts && opts.enabled) {
      gtag =
        gtag ||
        function (...args: []): void {
          (window.dataLayer = window.dataLayer || []).push(args);
        };
      gtag('js', new Date());
      gtag('config', 'UA-57041527-10', {
        custom_map: { dimension1: 'svar' },
      });
    } else {
      gtag = function (): void {
        // empty function when GA disabled
      };
    }
  }

  public trackEvent(event: {
    action: string;
    properties?: EventProperties;
  }): void {
    gtag('event', event.action, event.properties);
  }
}
